// File: config.appbarUserMenu.ts
// Author: James L Seebach
// Date: 5/15/2017
// Desc: Configuration file for app bar user menu.
// Other Contributors: Joseph M Diaz

export const appBarUserMenu = {
	items: [
		{ name: ' User Profile', action: 'openProfileDialog', icon: 'fa fa-user-o' },
        { name: ' MESC Help', action: 'helpLink', icon: 'fa fa-question-circle-o' },
		{ name: ' Logout', action: 'logOut', icon: 'fa fa-sign-out' },
		{ name: ' Switch Module', action: 'switchModule', icon: 'fa fa-toggle-on' }
	]
};
